// A checkbox element
/*
	Example:
	<CheckBox checked={isChecked} onClick={setIsChecked} />
*/

import React from 'react';
import styled, { css } from 'styled-components';
import { FaCheck } from 'react-icons/fa';

const checkedStyles = css`
	background-color: ${({ theme }) => theme.colors.primary};

	svg {
		opacity: 1;
		color: #fff;
		transform: scale(1);
	}
`;

const hoverStyles = css`
	svg {
		opacity: 1;
	}
`;

const CheckOuter = styled.div`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 2rem;
	height: 2rem;
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
	cursor: pointer;
	transition: border-color 150ms ease, background-color 150ms ease;

	svg {
		font-size: 12px;
		opacity: 0;
		color: ${({ theme }) => theme.colors.borderColor};
		transform: scale(0.8);
		transition: opacity 150ms ease, color 150ms ease, transform 250ms ease;
	}

	&:hover {
		${hoverStyles};
	}

	${({ checked }) => checked && css`${checkedStyles}`};
`;

export const CheckBoxLabel = styled.label`
	font-size: 1.6rem;
	line-height: 1;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.black};
	margin-left: 1.5rem;
	cursor: pointer;
`;

export const CheckBox = props => (
	<CheckOuter {...props}>
		<FaCheck />
	</CheckOuter>
);

// Optional wrapper that invokes the same
// hover and checked styles as the checkbox itself

// Example usage:
/*
	<CheckBoxWrapper checked={isChecked}>
		<div>
			<CheckBox />
			<Text>Click here!</Text>
		</div>
	</CheckBoxWrapper>
*/
export const CheckBoxWrapper = styled.div`
	cursor: pointer;

	&:hover {
		${CheckOuter} {
			${hoverStyles};
		}
	}

	${({ checked }) => checked && css`
		${CheckOuter} {
			${checkedStyles};
		}
	`};
`;
